<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">Einstellungen</h5>
        <button class="btn btn-outline-secondary" type="button" title="Schließen" aria-label="Close" (click)="modalService.dismissAll()">
          <img src="assets/icons/close.svg" alt="Schließen" width="16" height="16" style="margin-bottom: 4px">
        </button>
    </div>
    <div class="modal-body">

        <div class="input-group">

          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" [(ngModel)]="appendToken" role="switch" id="switchAppendToken">
            <label class="form-check-label" for="switchAppendToken">User-Token anhängen</label>
          </div>

        </div>
        <div *ngIf="errors.length > 0" class="alert alert-danger" role="alert">
            <p *ngFor="let error of errors" [innerHTML]="error"></p>
        </div>
        <div *ngIf="warnings.length > 0" class="alert alert-info" role="alert">
            <p *ngFor="let warning of warnings" [innerHTML]="warning"></p>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Abbrechen</button>
        <button type="button" class="btn btn-primary" (click)="saveChanges()">Änderungen speichern</button>
    </div>
</div>
